import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import get from 'lodash/get';
import Button from 'yoda-core-components/lib/components/Button/Button';
import RichText from '../RichText/RichText';

const cx = classNames.bind();
const ctaLinkClick = (event, link, openInNewTab) => {
    event.preventDefault();
    const linkTarget = openInNewTab ? '_blank' : '_self';
    window.open(link, linkTarget);
};
const ShopAllButton = ({ dataItem, classname, buttonType }) => {
    const ctaLink = get(dataItem, 'link.url', '');
    const linkText = get(dataItem, 'linkText', '');
    const openInNewTab = get(dataItem, 'openInNewTab', false);
    if (linkText && ctaLink) {
        return (
            <Button
                type="linkbutton"
                linkUrl={ctaLink}
                onClick={(event) => ctaLinkClick(event, ctaLink, openInNewTab)}
                buttonType={buttonType}
                className={cx(classname)}
            >
                <RichText text={linkText} />
            </Button>
        );
    }
    return null;
};

ShopAllButton.defaultProps = {
    dataItem: {},
    classname: '',
    buttonType: 'Secondary',
};
ShopAllButton.propTypes = {
    dataItem: PropTypes.object,
    classname: PropTypes.string,
    buttonType: PropTypes.string,
};

export default ShopAllButton;
